<p-header> Share template with other users </p-header>
<div style="padding-top: 1em;">
    <form #f="ngForm" [formGroup]="form">
        <p-multiSelect
            defaultLabel="People"
            maxSelectedLabels="1"
            appendTo="body"
            [filter]="true"
            [options]="config.data.items"
            formControlName="Users"
        ></p-multiSelect>
    </form>
</div>
<div class="flex items-center justify-end mr-1 gap-2 mt-3">
    <button
            [disabled]="f.invalid"
            pButton
            class="p-button-success"
            label="Save"
            (click)="dialogRef.close(f.value)"
        ></button>
        <button
            pButton
            class="p-button-warning"
            cdkFocusInitial
            label="Cancel"
            (click)="dialogRef.close()"
        ></button>
</div>
